module.exports = __webpack_public_path__ + "img/logo_cainiao.1e68eb17.png";